import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu } from "antd";
import { FiEdit, FiPlus, FiSearch, FiShield, FiTrash2 } from "react-icons/fi";

import { confirm, modalSuccess } from "../../services/notifications";
import { actions, getToken, hasPermission } from "../../services/security";
import { TableContextProvider } from "../../store/table-context";

import Card from "../../Components/ui/card";
import Header from "../../Components/ui/header";
import Table from "../../Components/ui/table";
import Filters from "../../Components/ui/filters";
import { BASEURL } from "../../services/url";
import http from "../../services/http";

const PerfilesListPage = () => {
  let navigate = useNavigate();

  const title = "Perfiles";
  const icon = <FiShield />;
  const breadcrumb = [{ title: "Perfiles", url: "/perfiles" }];

  const [filters, setFilters] = useState([
    {
      type: "input",
      label: "Nombre",
      name: "nombre",
    },
  ]);

  const columns = [{ title: "Nombre", property: "nombre", sortable: true }];

  const menuSearch = [
    {
      key: "1",
      icon: <FiSearch />,
      label: "Ver",
    }
  ]

  const menuEdit = [
    {
      key: "1",
      icon: <FiEdit />,
      label: "Editar",
    }
  ]

  const menuDelete = [
    {
      key: "2",
      icon: <FiTrash2 />,
      label: "Eliminar",
    }
  ]

  const menu = (item) => (
    <div>
      {!hasPermission(actions.PerfilesEditar) && (
        <Menu items={menuSearch} onClick={() => onClickEdit(item)} />
      )}

      {hasPermission(actions.PerfilesEditar) && (
        <Menu items={menuEdit} onClick={() => onClickEdit(item)} />
      )}
      {hasPermission(actions.PerfilesEliminar) && (
        <Menu items={menuDelete} onClick={() => onClickDelete(item)} />
      )}
    </div>
  );

  const onClickAdd = () => {
    navigate("/perfiles/nuevo");
  };

  const onClickEdit = (item) => {
    navigate(`/perfiles/${item.id}`);
  };

  const onClickDelete = async (item) => {
    const confirmed = await confirm(
      "Eliminar perfil",
      `¿Esta seguro que desea eliminar el perfil ${item.nombre}?`
    );
    if (!confirmed) {
      return;
    }
    const response = await http.delete(`${BASEURL}/perfiles/${item.id}`);
    if (response) {
      await modalSuccess(
        "Perfil eliminado",
        "El perfil fue eliminado exitosamente"
      )
      navigate(0);
    }
  };

  const buttons = [
    {
      title: "Agregar Perfil",
      text: <FiPlus />,
      type: "primary",
      onClick: onClickAdd,
      visible: true,
    },
  ];

  return (
    <TableContextProvider>
      <Card>
        <Header
          title={title}
          icon={icon}
          breadcrumb={breadcrumb}
          showFilters
          buttons={buttons}
        />
        <Filters fields={filters} />
        <Table
          id="table-perfiles"
          columns={columns}
          menu={menu}
          url="/perfiles"
          orderBy="nombre"
          orderDirection="ascending"
        />
      </Card>
    </TableContextProvider>
  );
};

export default PerfilesListPage;
